import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import type { DateTimePicker as DateTimePickerProps } from '@sato/components';
import { DateTimePicker } from '@sato/components';

import { useLanguage } from '@hooks/useTranslate';

interface Props
  extends Omit<DateTimePickerProps, 'onChange' | 'locale' | 'errorMessage'> {
  name: string;
  required?: boolean;
}

export const HookFormDateTimePicker = (props: Props) => {
  const { control } = useFormContext();
  const language = useLanguage();

  return (
    <Controller
      name={props.name}
      control={control}
      render={({ field, fieldState }) => (
        <DateTimePicker
          {...props}
          {...field}
          locale={language}
          error={!!fieldState.error}
          errorMessage={fieldState.error?.message}
        />
      )}
    />
  );
};
